import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const NetworkIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z'
                fill='currentColor'
            />
            <Path
                d='M12 19C13.8809 19 15.6667 15.9388 15.6667 12C15.6667 8.06124 13.8809 5 12 5C10.1191 5 8.33333 8.06124 8.33333 12C8.33333 15.9388 10.1191 19 12 19ZM12 20C9.42267 20 7.33333 16.4183 7.33333 12C7.33333 7.58172 9.42267 4 12 4C14.5773 4 16.6667 7.58172 16.6667 12C16.6667 16.4183 14.5773 20 12 20Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.5 4.66667V8H18.6667V9H12.5V11.5H19.3333V12.5H12.5V15H18.6667V16H12.5V19.3333H11.5V16H5.33333V15H11.5V12.5H4.66667V11.5H11.5V8.99933L5.33333 9V8L11.5 7.99933V4.66667H12.5Z'
                fill='currentColor'
            />
        </>
    ),
})

NetworkIcon.displayName = 'NetworkIcon'
